import { render, staticRenderFns } from "./resetPwdDialog.vue?vue&type=template&id=d3b3c838&scoped=true"
import script from "./resetPwdDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPwdDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./resetPwdDialog.vue?vue&type=style&index=0&id=d3b3c838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b3c838",
  null
  
)

export default component.exports